import React from "react";
import { SectionHeroGenericDataModel } from "./hero/types";
import { SectionsMap } from './sections.map';


type SectionsProps = {
    sections: Array<any>;
};


const isLazyComponent = (component: unknown): component is React.LazyExoticComponent<any> => {
    return typeof component !== 'function';
};


export const Sections = (props: SectionsProps) => {

    return <>
        {props.sections.map((section, index) => {
            if (!section.__typename) return null;

            // Get the component name from the full typename generated by Tina
            // This assumes that the object containing section components is named "content"
            const matches = /.+Content(.+)/.exec(section.__typename);

            if (!matches) return null;
            const name = matches[1] as keyof typeof SectionsMap;

            if (!SectionsMap[name]) return null;
            const Component = (SectionsMap[name]);
            
            
            return isLazyComponent(Component) ? (
                <React.Suspense key={index}>
                    <Component key={index} data={section} order={index} />
                </React.Suspense>
            ) : (
                <Component key={index} data={section} />
            )
        })}
    </>
};